import React, { Component } from "react";
import { Card, CardContent } from "../../ui/card";
import { Button } from "../../ui/button";
import { Play, FileText, Pencil, Trash2, ExternalLink } from 'lucide-react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "../../ui/dialog";
import { userService } from "../../../_services";

class VideoCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videoid: '',
            delete_popup: false,
            userId: '',
            userName: '',
            deleteVideoLoader: false,
            deletesuccesmsg: '',
            isPdfAvailable: false,
        }
    }
    
    componentDidMount() {
        this.getVideoId()
        this.handleVideoPlay = this.handleVideoPlay.bind(this)
        this.handleImageOpen = this.handleImageOpen.bind(this)
        this.close_delete_pop = this.close_delete_pop.bind(this)
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.setState({ userId: Usermeta_Data.split(':')[0], userName: Usermeta_Data.split(':')[1] })
        const { videoData } = this.props;
        if (videoData?.mediaType === 'application/pdf' && videoData.mediaBase64) {
            fetch(videoData.mediaBase64, { method: 'HEAD' })
                .then((res) => {
                    if (res.ok) {
                        this.setState({ isPdfAvailable: true });
                    }
                })
                .catch(() => {
                    this.setState({ isPdfAvailable: false });
                });
        }
    }
    
    getVideoId() {
        if (this.props.videoData.mediaLink != undefined && this.props.videoData.mediaLink !== '') {
            const videoId = this.props.videoData.mediaLink.split('v=')[1];
            this.setState({ videoid: videoId });
        }
    }
    
    handleVideoPlay() {
        const videotitle = this.props.videoData ? this.props.videoData.mediaTitle : ''
        this.props.showVideoModal()
        this.props.getVideoId(this.state.videoid, videotitle)
    }
    
    handleImageOpen(base64Data, mimeType) {
        window.open(window.location.origin + base64Data, '_blank');
    }
    
    editVideo(e) {
        e.stopPropagation()
        this.props.editVideo()
    }
    
    close_delete_pop() {
        this.setState({ delete_popup: false })
    }
    
    open_delete_pop(e) {
        e.stopPropagation()
        this.setState({ delete_popup: true, deletesuccesmsg: '' })
    }
    
    deleteVideo() {
        this.setState({ deleteVideoLoader: true })
        try {
            const videoData = this.props.videoData
            userService.DeleteMedia(this.state.userId, this.state.userName, this.props.moduleId, videoData.mediaTitle, videoData.mediaLink, videoData.mediaId).then((response) => {
                this.setState({ deleteVideoLoader: false })
                if (response.length > 0 && response[0].code === '1') {
                    this.setState({ deletesuccesmsg: response[0].message })
                    this.props.videoDeleted()
                    setTimeout(() => {
                        this.close_delete_pop()
                    }, 1000)
                }
            })
        } catch (err) {
            this.setState({ deleteVideoLoader: false })
        }
    }
    
    render() {
        const isVideo = this.props.videoData?.mediaLink && !this.props.videoData?.mediaBase64;
        const isPdf = this.props.videoData?.mediaType === 'application/pdf';
        const isImage = this.props.videoData?.mediaBase64 && !isPdf;
        
        return (
            <>
                {this.props.videoData ? (
                    <Card className="group overflow-hidden transition-all hover:shadow-lg">
                        {/* Video/PDF/Image Thumbnail */}
                        <div 
                            className="relative aspect-video bg-gray-100 cursor-pointer" 
                            onClick={() => {
                                this.props.videoData?.mediaBase64 
                                    ? this.handleImageOpen(this.props.videoData?.mediaBase64, this.props.videoData?.mediaType) 
                                    : this.handleVideoPlay()
                            }}
                        >
                            {isVideo ? (
                                <>
                                    <img 
                                        src={`https://img.youtube.com/vi/${this.state.videoid}/0.jpg`}
                                        className="w-full h-full object-cover"
                                        alt={this.props.videoData.mediaTitle}
                                    />
                                    <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors">
                                        <div className="bg-brand-accent rounded-full p-3 group-hover:scale-110 transition-transform">
                                            <Play className="h-6 w-6 text-white fill-white" />
                                        </div>
                                    </div>
                                </>
                            ) : isPdf ? (
                                <>
                                    {this.state.isPdfAvailable ? (
                                        <iframe 
                                            src={this.props.videoData.mediaBase64}
                                            className="w-full h-full pointer-events-none"
                                            title={this.props.videoData.mediaTitle}
                                        />
                                    ) : (
                                        <div className="flex items-center justify-center h-full">
                                            <p className="text-sm text-gray-500 font-medium">PDF file not found</p>
                                        </div>
                                    )}
                                    <div className="absolute inset-0 flex items-center justify-center bg-black/0 group-hover:bg-black/10 transition-colors pointer-events-none">
                                        <div className="bg-brand-accent rounded-full p-3 group-hover:scale-110 transition-transform">
                                            <FileText className="h-6 w-6 text-white" />
                                        </div>
                                    </div>
                                </>
                            ) : isImage ? (
                                <>
                                    <img 
                                        src={this.props.videoData.mediaBase64}
                                        className="w-full h-full object-cover"
                                        alt={this.props.videoData.mediaTitle}
                                    />
                                    <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors">
                                        <div className="bg-brand-accent rounded-full p-3 group-hover:scale-110 transition-transform">
                                            <ExternalLink className="h-6 w-6 text-white" />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className="flex items-center justify-center h-full bg-gray-50">
                                    <FileText className="h-16 w-16 text-gray-400" />
                                </div>
                            )}
                            
                            {/* Action Buttons on Hover */}
                            <div className="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                                <Button 
                                    variant="secondary" 
                                    size="icon" 
                                    className="h-8 w-8 bg-white hover:bg-gray-100"
                                    onClick={this.editVideo.bind(this)}
                                >
                                    <Pencil className="h-4 w-4" />
                                </Button>
                                <Button 
                                    variant="destructive" 
                                    size="icon" 
                                    className="h-8 w-8"
                                    onClick={this.open_delete_pop.bind(this)}
                                >
                                    <Trash2 className="h-4 w-4" />
                                </Button>
                            </div>
                        </div>
                        
                        {/* Title */}
                        <CardContent className="p-3">
                            <h4 className="text-md font-bold text-brand-dark truncate" title={this.props.videoData.mediaTitle}>
                                {this.props.videoData.mediaTitle}
                            </h4>
                        </CardContent>
                    </Card>
                ) : null}
                
                {/* Delete Confirmation Dialog */}
                <Dialog open={this.state.delete_popup} onOpenChange={this.close_delete_pop}>
                    <DialogContent>
                        <DialogHeader>
                            <DialogTitle>Delete Video</DialogTitle>
                            <DialogDescription>
                                Are you sure you want to delete this video?
                            </DialogDescription>
                        </DialogHeader>
                        {this.state.deletesuccesmsg && (
                            <p className="text-sm text-green-600">{this.state.deletesuccesmsg}</p>
                        )}
                        <DialogFooter>
                            <Button 
                                variant="outline" 
                                onClick={this.close_delete_pop}
                                disabled={this.state.deleteVideoLoader}
                            >
                                No
                            </Button>
                            <Button 
                                variant="destructive" 
                                onClick={this.deleteVideo.bind(this)}
                                disabled={this.state.deleteVideoLoader}
                            >
                                {this.state.deleteVideoLoader ? 'Deleting...' : 'Yes'}
                            </Button>
                        </DialogFooter>
                    </DialogContent>
                </Dialog>
            </>
        )
    }
}

export default VideoCard;
